import { IsOptional } from 'class-validator'
import { BooleanParse } from '../decorators/parsers.decorator'
import { PaginatedSearchDTO } from './paginated-search.dto'

export class SiteVisitPaginatedSearchDTO extends PaginatedSearchDTO {
  @IsOptional()
  @BooleanParse()
  completed?: boolean
}
